import { apiClient } from './index.js';
import { sanitizePostData } from '@/utils/index.js';

async function updateActivity({ activityCVId, activityId, level, story }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Profile/UpdateActivityCV',
    data: sanitizePostData({ activityCVId, activityId, level, story }),
    generalErrorsOnly: true,
  });
  return data;
}

async function removeActivity({ activityCVId }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Profile/RemoveActivityCV',
    data: sanitizePostData({ activityCVId }),
    generalErrorsOnly: true,
  });
  return data;
}

async function addActivity({ activityId, level, story }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Profile/AddActivityCV',
    data: sanitizePostData({ activityId, level, story }),
    generalErrorsOnly: true,
  });
  return data;
}
async function getCurrentUserFullActivityCV({ activityCVId }) {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/Profile/GetCurrentUserFullActivityCV',
    params: { ActivityCVId: activityCVId },
  });
  return data;
}
async function getFullActivityCVByUserId({ activityCVId, userId }) {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/Profile/GetFullActivityCVByUserId',
    params: { ActivityCVId: activityCVId, UserId: userId },
    isAuthCheckSkipped: true,
  });
  return data;
}

const activityImageCache = new Map();

async function getActivityImage(activityId) {
  // Check if the image is already cached
  if (activityImageCache.has(activityId)) {
    //console.log(`Returning cached image for activityId: ${activityId}`);
    return activityImageCache.get(activityId);
  }

  try {
    // Fetch the image from the API
    const { data, headers } = await apiClient({
      method: 'get',
      url: '/api/Team/GetActivityPicture',
      params: { ActivityId: activityId },
      responseType: 'arraybuffer',
    });

      // Extract content type from headers
    const contentType = headers['content-type'];

    // Create a Blob from the received data
    const blob = new Blob([data], { type: contentType });

    // Cache the image
    activityImageCache.set(activityId, blob);

    // Return the Blob or a URL for it (depending on usage)
    return blob;
  } catch (error) {
    console.error(`Error fetching image for activityId: ${activityId}`, error);
    throw error;
  }
}


export {
  updateActivity,
  removeActivity,
  addActivity,
  getCurrentUserFullActivityCV,
  getFullActivityCVByUserId,
  getActivityImage
};
